module.exports = global["Tether"] = require("-!/home/dario/development/ok17/themes/ok2021/_dev/node_modules/babel-loader/lib/index.js!./tether.js");